import React, { useState, useEffect } from 'react';
import './ProcurementCreateContract.css';
import { queuedApiFetch, apiFetch } from '../api';

function ProcurementCreateContract({ buttonId }) {
    const [dataLoading, setDataLoading] = useState(false);
    const [itemList, setItemList] = useState([]);
    const getProjectDetails = localStorage.getItem('projectDetails');
    const selectedProjectDetail = JSON.parse(getProjectDetails);
    //new code updations
    const getUserDetails = localStorage.getItem('userDetails');
    const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';
    const userId = userDetails ? userDetails.id : '';
    const getUserAccess = userDetails ? userDetails.access_level : '';
    const [userCompany, setUserCompany] = useState();
    const getUserCompanyDetails = userCompany;
    const getUserEmail = localStorage.getItem('userEmail');
    const [userPermission, setUserPermission] = useState();
    const [loading, setLoading] = useState(true);
    let parametervalue = 0;

    //Parameter passing
    if (getUserCompanyDetails === "NUS") {
        parametervalue = 1;
    } else {
        parametervalue = 0;
    }

    let p_access = selectedProjectDetail.Proj_Access.proj_access_level;
    let p_roles = selectedProjectDetail.Proj_Access.proj_role.join(", ");
    let proj_name=selectedProjectDetail?.projectName;


    let qs_params = `nususer=${parametervalue}&project_admin=${(p_access) ? 1 : 0}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;

    const procurementName = buttonId === 'ConsultantCreateContract' ? 'Consultant' : 'Contractor';
    const projectid = selectedProjectDetail.projectNumber;
    const ContractorCreateContractIframe = `https://acc.autodesk.com/cost/cost/projects/${projectid}/contracts?${qs_params}${procurementName.toLowerCase() === 'consultant' ? '&menu=Procurement Consultant_Create Contract' : '&menu=Procurement Contractor_Create Contract'}`;

        
    useEffect(() => {
        if (projectid) {
             fetchData();
        }
    }, []);
    
    useEffect(() => {
        fetchUserCompany();
    }, []);

    const fetchData = async () => {
        setDataLoading(true);
        const requestOptions = {
            method: "GET",
            //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
        };

        try {
            // const procurementName = buttonId === 'ConsultantCreateContract' ?  'consultant' : 'contractor';
            // const response = await queuedApiFetch(`/project/get_procurement_contractList?project_id=${projectid}&procurement=${procurementName}`,
            //     requestOptions
            // );
            const response = await queuedApiFetch(`/project/get_create_contract_list?project_id=${projectid}&procurement=${procurementName}`,
                requestOptions
            );
            const data = await response;
            if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
                setItemList(data.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setDataLoading(false);
        }
    };
    const fetchUserCompany = async () => {
        const requestOptions = {
          method: 'GET',
          //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
        };
         try {
          const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
          const data = await response;
      
          if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
            setUserCompany(data.data.company_name);
            setUserPermission(data.data.access_level);     
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setLoading(false); // End loading
        }
      }

    return (
        // <html style={{ overflowY: "auto", width: "100%", background: "#fff" }}>
          
        //     <body style={{ background: "white" }}>
        //     </body>
        // </html>
              <div style={{width: "100%", background:"#e7e6e6"}}>
                  <div className="tablewrap1">
                    <div className="title-box">List of approved procurement requests</div>
                    {/* <p className="subtitle">Please select Contractor to create contract</p> */}
                    <p className="subtitle">{buttonId === 'ConsultantCreateContract' ?  'Please select Consultant to create contract' : 'Please select Contractor to create contract'}</p>
                    <div style={{overflowX: "auto"}} className="tablewrap">
                        <table className="procurement-table">
                            <thead>
                                <tr>
                                    <th>{buttonId === 'ConsultantCreateContract' ?  'Consultant Name' : 'Contractor Name'}</th>
                                    <th>Procurement Type</th>
                                    <th>Procurement Request Approved On</th>
                                    <th>Contract Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataLoading ? (
                                    <tr>
                                        <td colSpan="4" className="text-center">Loading...</td>
                                    </tr>
                                ) : (
                                    itemList && itemList.length > 0 ? (
                                        itemList
                                            // .filter(item => item.status === 'submitted' && item.approved_on !== 'Rejected')
                                            .length > 0 ? (
                                                itemList
                                                    // .filter(item => item.status === 'submitted' && item.approved_on !== 'Rejected')
                                                    .map((item, index) => (
                                                        <tr key={index} style={{background:(item.background), color:(item.text_color)}}>
                                                            <td
                                                                className="consultant-name"
                                                                // onClick={() => window.location.replace(ContractorCreateContractIframe)}
                                                                onClick={() => window.open(ContractorCreateContractIframe, "_blank")}
                                                                style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                                                            >
                                                                {item.consultant_name}
                                                            </td>
                                                            <td>{item.procurement_type}</td>
                                                            <td>{item.approved_on}</td>
                                                            {/* <td>{item.status === "submitted" ? "executed" : item.status}</td> */}
                                                            <td>{item.status}</td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">No records found</td>
                                                </tr>
                                            )
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">No records found</td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>

                    </div>
                </div>
              </div>
    );
}

export default ProcurementCreateContract;